import { UtilHelper } from '../../../shared/helpers/utils.helper';

export class OrderLocalConfig {
  orderAudioVolume: number;
  repeatOrderAudio: boolean;

  constructor() {
    let audioVolume = UtilHelper.getCustomPrefs('orderAudioVolume');
    this.orderAudioVolume = audioVolume == null ? 50 : Number(audioVolume);
    this.repeatOrderAudio = UtilHelper.getBoolPrefs('repeatOrderAudio', null, true);
  }

  static get(): OrderLocalConfig {
    return new OrderLocalConfig();
  }

  save(): void {
    UtilHelper.setPrefs('orderAudioVolume', String(this.orderAudioVolume));
    UtilHelper.setPrefs('repeatOrderAudio', this.repeatOrderAudio ? 'true' : 'false');
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/models/order-config.model.ts